<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
   
    methods:{
        init: (payload) => {

            const el = document.body;
            el.removeAttribute("class");
            $('.modal').modal('hide');

            setTimeout(async function(){
            let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
            if (response && response.status==200){
               
                let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
                if (response && response.status==200){
                    
                    let truckTrailer = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), 
                    {systemUser:response.result._id,vehicleTypes:["TRUCKTRAILER_VANDERLEIA", "TRUCKTRAILER_CONVENCIONAL" ,"TRUCKTRAILER_DOLLY"]}, 
                    `${Endpoints.trucks.listByType}`));
                    if (truckTrailer.status==200){
                        payload.truckTrailers = truckTrailer.data.results;
                    }
                    
                    let truck = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), 
                    {systemUser:response.result._id,vehicleTypes:["TRUCK_VUC", "TRUCK_TOCO" ,"TRUCK_TRUCK","TRUCK_MECHANICAL_HORSE_SIMPLE",
                    "TRUCK_MECHANICAL_HORSE_TRUCADO","TRUCK_MECHANICAL_HORSE_TRACADO","TRUCK_DOUBLE_TRAIN","TRUCK_RODOTREM"]}, `${Endpoints.trucks.listByType}`));
                    if (truck.status==200){
                        payload.trucks = truck.data.results;
                    }

                    let trucker = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload),{company:response.result.companyUser.company._id},
                     `${Endpoints.systemUsers.filter}`));
                    if (truck.status==200){
                        payload.truckers = trucker.data.results;
                    }
                }
            }
        }, 100);
           
        },
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;
            Request.do(this, this.data._id ? 'PUT' : 'POST', Request.getDefaultHeader(this), this.data, `${Endpoints.systemUsers.systemUser}${this.data._id ? this.data.email : ''}`,
                (response)=>{//SUCCESS CALLBACK
                    state.data._id = response.result._id;
                    state.valuekey += 1;
                    $('#spinner').modal('toggle');
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
         selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
            this.data.firstName = Common.camelize(this.data.firstName);
            this.data.lastName = Common.camelize(this.data.lastName);

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

        },
        checkTruckType: function(type){
            if(type == "TRUCK_VUC" || type == "TRUCK_TOCO" || type == "TRUCK_TRUCK"){
                return 1;
            }
            return -1;
        },
      
        clearForm: function(){
            this.data = {};
            this.data.customerUser={};
        },
        checkForm: function (e) {
            this.errors = [];
            if (!this.data.truckType.name) {
                this.errors.push(this.$t('response.truck.register.type.required'));
            }
            if (!this.data.manufacturer.name) {
                this.errors.push(this.$t('response.truck.register.manufacturer.required'));
            }
            if (!this.data.plate) {
                this.errors.push(this.$t('response.truck.register.plate.required'));
            }
            if (!this.data.renavam) {
                this.errors.push(this.$t('response.truck.register.renavam.required'));
            }
            if (!this.data.yearFabrication) {
                this.errors.push(this.$t('response.truck.register.yearFabrication.required'));
            }
            if (!this.data.document) {
                this.errors.push(this.$t('response.truck.register.document.required'));
            }
            if (!this.data.documentPhoto) {
                this.errors.push(this.$t('response.truck.register.documentPhoto.required'));
            }
          
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                console.log("##### DATA:");
                console.log(this.data);
                this.save();
            }
        },
        customLabel (option) {
            return `${option.name} - ${option.manufacturer.name} - ${option.plate} - ${option.year}`
        },
         camelize: Common.camelize,
         toUpperCase: Common.toUpperCase,
    }
}
</script>
